<template>
<div>
    <div class="block">
        <div class="block-box -left">
            品詞
        </div>
        <div class="block-box -right">
            <div class="form-group form-group-space-no">
               <v-select label="partname" class="part-select w-50" v-model="partSelectObj"  :options="partList"></v-select>  
               <v-select label="subpartname" class="part-select w-50" v-model="subPartSelectObj"  :options="subPartList">
                   <span  slot="no-options">親品詞を選択してください</span >
               </v-select>  

<!--
               <v-select class="w-50" :value="partSelected" label="partname" :options="partList" :onChange="changePart" style="display: inline-block;"></v-select>
               <v-select class="w-50" v-model="subPartSelected" label="subpartname" :options="subPartList"></v-select>
               -->
               <!--
                <select class="browser-default custom-select w-50" v-model="subPartSelected" v-on:change="changeSubPart" v-bind:disabled="isSubPartSelected">
                    <option value=""></option>
                    <option v-for="(subpart,index) in subPartList" :key="index" :value="subpart.subpartid" >
                       {{subpart.subpartname}} 
                    </option>
                </select>
                -->
            </div>
        </div>
    </div><!-- / block -->

    <div class="block">
        <div class="block-box -left">
            活用型
        </div>
        <div class="block-box -right">
            <div class="form-group form-group-space-no">
                <!--
                <select class="selectpicker w-100" disabled>
                    <option>選択する</option>
                    <option></option>
                    <option></option>
                </select>
                -->
               <v-select label="sinflectionname" class="part-select w-100" v-model="inflectionSelectObj"  :options="inflectionList">
                   <span  slot="no-options">選択可能な活用型はありません</span >
               </v-select>  

            </div>
        </div>
    </div><!-- / block -->
</div>
</template>
<style>
.part-select{
    display: inline-block;
    vertical-align: top;
}

.v-select .dropdown-toggle{
    background-color: white;
}
</style>
<script>
//import vSelect from 'vue-select'
import vSelect from 'vue-select'
import {API_URL} from '@/services/config'

export default {
  name: 'PartSelector',
  props: {
    partdata:String,
    subpartdata:String,
    inflectiondata:String
  },
  components:{
      vSelect
  },
  data(){
      return {
      partData:[],          //品詞データ
      partSubData:[],       //下位品詞
      inflectionData:[],    //活用型


    
      partList:[],          //品詞リスト表示用
      subPartList:[],       //下位品詞リスト表示用
      inflectionList:[],     //活用型リスト表示用

      partSelectObj:'',          //品詞r
      subPartSelectObj:'',       //下位品詞
      inflectionSelectObj:'',     //活用型

      partSelected:'',          //品詞
      subPartSelected:'',       //下位品詞
      inflectionSelected:'',     //活用型

      isSubPartSelected:true,       //下位品詞
      isInflectionSelected:true,     //活用型

      testsel:'',
      testdata:[
          {id:'01',name:'test'}]
      }
  },
mounted(){
      var self = this;

      self.$axios.get(`${API_URL}/search/getSelectbox`)
      .then((res) => {
          self.partData = res.data.part;
          self.partSubData = res.data.subpart;
          self.inflectionData = res.data.inflection;
          self.partList = self.partData;
      });


  },
  watch:{
         /* 品詞のチェンジイベント */
        'partSelectObj': function(){
            var self = this;
            self.subPartList=[];       //下位品詞リスト表示用
            self.inflectionList=[];     //活用型リスト表示用 
            self.isSubPartSelected = true;       //下位品詞
            self.isInflectionSelected = true;     //活用型 
            self.partSelected = '';
            self.subPartSelected = '';            //
            self.inflectionSelected = '';         //
            self.subPartSelectObj = null;
            self.inflectionSelectObj = null;

            if(self.partSelectObj !== null){
                self.partSelected =self.partSelectObj.partid; 
                if(self.partSubData[self.partSelectObj.partid]){
                    self.subPartList = self.partSubData[self.partSelectObj.partid];
                    self.isSubPartSelected = false;       //下位品詞
                }

                if(self.inflectionData[self.partSelectObj.partid]){
                    self.inflectionList = self.inflectionData[self.partSelectObj.partid]; 
                    self.isInflectionSelected = false;     //活用型 
                }
            }
            self.$emit('on-select-part', self.partSelected, self.subPartSelected, self.inflectionSelected); 
        },
        'subPartSelectObj': function(){
            var self = this;
            self.subPartSelected = '';
            if(self.subPartSelectObj !==null){
               self.subPartSelected = self.subPartSelectObj.subpartid; 
            }
            self.$emit('on-select-part', self.partSelected, self.subPartSelected, self.inflectionSelected); 
        },
        'inflectionSelectObj': function(){
            var self = this;
            self.inflectionSelected = '';
            if(self.inflectionSelectObj !==null){
               self.inflectionSelected = self.inflectionSelectObj.sinflectionid; 
            }
            self.$emit('on-select-part', self.partSelected, self.subPartSelected, self.inflectionSelected); 

        }
  },
  methods:{
     clear(){
      this.partSelectObj=''          //品詞r
      this.subPartSelectObj=''       //下位品詞
      this.inflectionSelectObj=''     //活用
     }
  }
}
</script>